module.exports = __webpack_public_path__ + "img/piiri_p_2025.d15712c6.png";